module.exports = {"pageTitleText":"第三方API金鑰","hintText":"請確認ID及KEY匹配正確，避免造成功能異常。","captcha":"Smart Captcha","vaptcha":"Gesture Challenge","placeholder":"請輸入"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/apiKeys.json
// module id = 7Bz/
// module chunks = 3